import styled from 'styled-components';

export default styled.div`
	display: grid;
	${({$columns}) => `grid-template-columns: ${$columns};`}
	grid-template-rows: auto;
	${({$areas}) => `grid-template-areas: '${$areas}';`}
	gap: var(--px-14);
	width: 100%;
	align-items: center;

	.search {
		grid-area: search;
	}

	.customize-columns {
		grid-area: customizeColumns;
	}

	.table-select {
		grid-area: tableSelect;
	}

	.export-data {
		grid-area: exportData;
	}
`;
